import React, { createContext, useContext, useState, useCallback } from 'react';
import { IRequestType } from '../constants/interfaces';

interface LayoutContextType {
  useGrid: boolean;
  handleToggle: (
    event: React.MouseEvent<HTMLElement>,
    newValue: boolean | null
  ) => void;
  selectedRequestType: IRequestType | null;
  setSelectedRequestType: (requestType: IRequestType | null) => void;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export function LayoutProvider({ children }: { children: React.ReactNode }) {
  // Initialize from localStorage if available
  const getInitialGrid = () => {
    if (typeof window !== 'undefined') {
      const stored = window.localStorage.getItem('servicerportal.useGrid');
      if (stored === 'true') return true;
      if (stored === 'false') return false;
    }
    return false;
  };
  const [useGrid, setUseGrid] = useState<boolean>(getInitialGrid);
  const [selectedRequestType, setSelectedRequestType] =
    useState<IRequestType | null>(null);

  const handleToggle = useCallback(
    (_event: React.MouseEvent<HTMLElement>, newValue: boolean | null) => {
      if (newValue !== null) {
        setUseGrid(newValue);
        if (typeof window !== 'undefined') {
          window.localStorage.setItem(
            'servicerportal.useGrid',
            String(newValue)
          );
        }
      }
    },
    []
  );

  return (
    <LayoutContext.Provider
      value={{
        handleToggle,
        selectedRequestType,
        setSelectedRequestType,
        useGrid,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
}

export function useLayout() {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
}
